module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "hot_content"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: item.commentID + '' + index
    }, [_c('div', {
      staticClass: "hot-comment-top"
    }, [_c('div', {
      staticClass: "conTop_left"
    }, [_c('div', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "conTop_img",
      style: ({
        backgroundImage: ("url(" + ((item.type === 2 || item.userID === -1 || item.userID === 0 || item.userID === -3) && _vm.govImage ? _vm.govImage : item.faceUrl) + ")")
      })
    }), _vm._v(" "), (item.commentOfficial && (item.type === 2 || item.userID === -1 || item.userID === 0 || item.userID === -3)) ? _c('img', {
      staticClass: "conTop_img-official",
      attrs: {
        "src": item.commentOfficial,
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "conTop_name"
    }, [_c('p', {
      staticClass: "conTop_name_user themeColor",
      domProps: {
        "innerHTML": _vm._s(_vm.parseSpace((item.type === 2 || item.userID === -1 || item.userID === 0 || item.userID === -3) && !item.userName ? '官方发布' : item.userName))
      }
    })])]), _vm._v(" "), _c('commentOperation', {
      attrs: {
        "item": item
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "conContent",
      domProps: {
        "innerHTML": _vm._s(_vm.parseSpace(item.content))
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "c-createTime"
    }, [_vm._v("\n        " + _vm._s(_vm._f("parseDateTime")(item.createTime)) + "\n        "), _c('span', {
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(_vm._f("parseDateTime")(item.createTime)))]), _vm._v(" "), (_vm.ipSwitch == 1 && item.ip) ? _c('span', {
      staticStyle: {
        "display": "inline-block"
      },
      domProps: {
        "textContent": _vm._s(!item.ipAddress && 'IP：未知' || 'IP：' + item.ipAddress)
      }
    }) : _vm._e()]), _vm._v(" "), (item.parentID > 0 && item.parentContent) ? _c('div', {
      staticClass: "news_comment_reply_info"
    }, [_c('div', {
      staticClass: "news_comment_reply_info_top"
    }, [_c('p', {
      staticClass: "news_comment_nickname",
      domProps: {
        "innerHTML": _vm._s(_vm.parseSpace(item.parentUserName))
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "news_comment_text",
      domProps: {
        "innerHTML": _vm._s(_vm.parseSpace(item.parentContent))
      }
    })]) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-111f9b18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comments/commentContent.vue
// module id = 285
// module chunks = 1